<mat-card class="widget">
  <div>
    <div class="fab-buttons">
      <fab-no-title [icon]="'edit'" (click)="edit()"></fab-no-title>
    </div>
    <div class="user-content">
      <h1>{{ 'profile.profile_userinfo_label' | translate }}</h1>
      <div class="user-content-container">
          <div class="info">
            <span style="padding-top: 5px;" >{{ 'profile.username_label' | translate}}: {{userInfo?.userName}}</span>
            <span>{{ 'profile.email_label' | translate}}: {{userInfo?.email}}</span>
            @if (isSubscribed) {
              <span>{{ 'profile.firstname_label' | translate}}: {{userInfo?.firstName}}</span>
              <span>{{ 'profile.lastname_label' | translate}}: {{userInfo?.lastName}}</span>
            }
            <span>{{ 'profile.birthday_label' | translate}}: {{userInfo?.birthDay}}</span>
          </div>
      </div>
    </div>
  </div>
</mat-card>